import moment from 'moment';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
var Duration = function (_a) {
    var start = _a.start, end = _a.end;
    var t = useTranslation()[0];
    start = moment(start);
    end = moment(end);
    var duration = moment.duration(end.diff(start));
    var years = duration.years();
    var months = duration.months();
    var days = duration.days();
    var hours = duration.hours();
    var minutes = duration.minutes();
    var seconds = duration.seconds();
    var output = [];
    if (years > 0) {
        output.push(t('years_count', { count: years }));
    }
    if (months > 0) {
        output.push(t('months_count', { count: months }));
    }
    if (days > 0) {
        output.push(t('days_count', { count: days }));
    }
    if (hours > 0) {
        output.push(t('hours_count', { count: hours }));
    }
    if (minutes > 0) {
        output.push(t('minutes_count', { count: minutes }));
    }
    if (seconds > 0) {
        output.push(t('seconds_count', { count: seconds }));
    }
    return React.createElement(Fragment, null, output.join(', '));
};
export default Duration;
